import React from 'react';
import '../style/Loader.css'

const Loader = () => {
    return(
        <>
        <div class='load_container'>
            <img src='https://img.pikbest.com/png-images/20190918/cartoon-snail-loading-loading-gif-animation_2734139.png!bw700' alt='loader icon' />
        </div>
        </>
    )
}

export default Loader;